import { required } from 'vuelidate/lib/validators'
import Pagination from "../../../components/Pagination.vue";
import AIModelService from "../../../services/AIModel.service";
import { alertResponseSuccess, alertResponseError } from "../../../helpers/general";
import { ERRORS_CODE } from "../../../const/error_code";
import { INFERENCE_STATUS } from "../../../const/aimodel";
import * as Swal from "sweetalert2";

export default {
    components: {
        appPagination: Pagination
    },
    data() {
        return {
            page_title: '',
            pagination : {
                currentPage: 1,
                pageCount: 1,
            },
            errors: {},
            aiModel: {
                id: '',
                name: ''
            },
            formSubmitted: false,
            record_condition: '',
            model_training_id: '',
            pred_field_prefix: 'pred_',
            option_thresh: 0.5,
            inferences: [],
            finishTraines: [],
            INFERENCE_STATUS: INFERENCE_STATUS
        }
    },
    methods: {
        inference() {
            Swal.fire({
                text: this.$t("ai_model_inference.confirm"),
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: this.$t('common.yes'),
                cancelButtonText: this.$t('common.no'),
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    return AIModelService.inference(
                            this.aiModel.id,
                            this.record_condition,
                            this.model_training_id,
                            this.pred_field_prefix,
                            this.option_thresh
                    ).then((response) => {
                    
                        this.formSubmitted = false;
                        if (response.data.success) {
                            alertResponseSuccess(this.$t("common_message.inference_success"));
                        }
                        this.getAllInferences(this.aiModel.id);
                    }).catch((error) => {
                        this.getAllInferences(this.aiModel.id);
                        if(error.response.data.errorCode === ERRORS_CODE.NO_PLAN_SUBSCRIBE) {
                            alertResponseError(this.$t("message_error.CAN_NOT_CREATE_OR_EDIT_AI_MODEL"));
                        }  else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_NOT_FOUND) {
                            alertResponseError(this.$t("message_error.SUBSCRIPTION_NOT_FOUND"));
                        } else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_IS_NOT_ACTIVE) {
                            alertResponseError(this.$t("message_error.SUBSCRIPTION_IS_NOT_ACTIVE"));
                        } else if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_NOT_FOUND) {
                            alertResponseError(this.$t("message_error.CAN_NOT_START_PLAN"));
                        }else {
                            return alertResponseError(error.response.data.error);
                        }
                        
                    });
                }
            });
        },
        handleForm() {
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            return this.inference();
        },
        getAllInferences(id) {
            AIModelService.getAllInferences(id, this.pagination.currentPage).then((response) => {
                this.inferences = response.data.data.results;
                this.pagination.pageCount = response.data.data.count;
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found"));
                } else {
                    alertResponseError(error);
                }
            });
        },
        getAllFinishTrains(id) {
            AIModelService.getAllFinishTrains(id).then((response) => {
                this.finishTraines = response.data.data.results;
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found"));
                } else {
                    alertResponseError(error);
                }
            });
        },

        
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        this.page_title = document.title;
        this.aiModel.id = this.$route.params.id;
        this.aiModel.name = this.$route.params.name;
        this.getAllInferences(this.aiModel.id);
        this.getAllFinishTrains(this.aiModel.id);
    },
    computed: {
        kintoneRecordConditionErrorMsg() {
            /*
            if (!this.$v.kintone_record_condition.required) {
                return this.$t('message_error.ORGANIZATION_NAME_REQUIRED');
            }
            */

            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        },     
        modelTrainingIdErrorMsg() {
            if (!this.$v.model_training_id.required) {
                return this.$t('message_error.SELECT_TRAINING_MODEL');
            }
            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        },
        kintonePredFieldPrefixErrorMsg() {
            if (!this.$v.pred_field_prefix.required) {
                return this.$t('message_error.ENTER_PREFIX_KINTONE_FIELD');
            }
            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        },
        kintoneOptionThreshErrorMsg() {
            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        }  
    },
    validations() {
        return {
            kintone_record_condition: {  },
            model_training_id: { required },
            pred_field_prefix: { required },
            option_thresh: {  },
        }
    }
}